export default class CAAA1020RequestModel {
  cntctNo: string
  cmpnyNo: string
  persnInfoAgrAvail: number
  critDay: string
}
